import Vue from 'vue'
import Vuex from 'vuex'
// modules Start
import {
    globalConfig,
} from '@/config'
import login from './modules/login'
import admin from './modules/admin'
import services from './modules/services'
import clients from './modules/clients'
import application from './modules/application'
import calendar from './modules/calendar'
import errors from './modules/errors'
import map from './modules/map'
import chat from './modules/chat'
import calls from './modules/calls'
import notifications from './modules/notifications'
import materials from './modules/materials'
import orders from './modules/orders'
import partners from './modules/partners'
import requests from './modules/requests'
import specialists from './modules/specialist'
import engineers from './modules/engineers'
import masters from './modules/masters'
import administrators from './modules/administrators'
import schedule from './modules/schedule'
import deleteControl from './modules/deleteControl'
import mails from './modules/mails'
import autocomplete from './modules/autocomplete'
import sip from './modules/sip'
import metrics from './modules/metrics'
import problems from './modules/problems'
import todo from './modules/todo'
import files from './modules/files'
import offices from './modules/offices'
import tools from './modules/tools'
import tags from './modules/tags'
import skills from './modules/skills'
import pdf from './modules/pdf'

import badges from './modules/badges'
import publicRoutes from './modules/public'

// modules End

window.requestConfig = {
    baseURL: globalConfig.baseUrl,
    headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    },
}

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        login,
        admin,
        services,
        clients,
        application,
        calendar,
        errors,
        map,
        chat,
        calls,
        notifications,
        materials,
        orders,
        partners,
        requests,
        specialists,
        masters,
        engineers,
        administrators,
        schedule,
        deleteControl,
        mails,
        autocomplete,
        sip,
        metrics,
        badges,
        problems,
        todo,
        files,
        offices,
        tools,
        tags,
        skills,
        pdf,

        public: publicRoutes,
    },
})

export default store
